module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_concept_02-7f0bf01d9eab436430de90b938c9e533.jpg";